import {
  searchArchivedRequests,
  searchBuildings,
  searchContractors,
  searchFlats,
  searchRequests,
} from '../../../api'
import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { searchEmails } from '../../Email'
import { searchPosts } from '../../Posts'
import { searchUsers } from '../../User'

/**
 * @template TData
 *
 * @param {ApiResponse<TData> | null} response
 *
 * @returns {TData}
 */
function getResponseData(response) {
  return response?.data
}

/**
 * @template {object} TItem
 *
 * @param {ApiResponse<TItem[]>} response
 *
 * @return {TItem[]}
 */
function getData(response) {
  return getResponseData(response) ?? EMPTY_LIST
}

/**
 * @template {object} TItem
 *
 * @param {ApiResponse<{results: {objects: TItem[]}}>} response
 *
 * @return {TItem[]}
 */
function getDataResultsObjects(response) {
  return getResponseData(response)?.results?.objects ?? EMPTY_LIST
}

/**
 * @param {CallSearchApiProps} props
 */
export function getBuildings({ apiConfig = EMPTY_OBJECT, config, search }) {
  return searchBuildings({
    apiConfig,
    archived: search.archived,
    query: search.text,
  })
    .then(getData)
    .then(items => ({ config, items, search }))
}

/**
 * @param {CallSearchApiProps} props
 */
export function getFlats({ apiConfig = EMPTY_OBJECT, config, search }) {
  return searchFlats({
    apiConfig,
    archived: search.archived,
    query: search.text,
  })
    .then(getData)
    .then(items => ({ config, items, search }))
}

/**
 * @param {CallSearchApiProps} props
 */
export function getEmails({ apiConfig = EMPTY_OBJECT, config, search }) {
  return searchEmails({
    apiConfig,
    archived: search.archived,
    query: search.text,
  })
    .then(getData)
    .then(items => ({ config, items, search }))
}

/**
 * @param {CallSearchApiProps} props
 */
export function getPosts({ apiConfig = EMPTY_OBJECT, config, search }) {
  return searchPosts(search.text, {
    ...apiConfig,
    params: { ...apiConfig.params, ordering: '-created' },
  })
    .then(getDataResultsObjects)
    .then(items => ({ config, items, search }))
}

/**
 * @param {CallSearchApiProps} props
 */
export function getRequests({ apiConfig = EMPTY_OBJECT, config, search }) {
  const searchApi = search.archived ? searchArchivedRequests : searchRequests

  return searchApi({ apiConfig, search: search.text })
    .then(getDataResultsObjects)
    .then(items => ({ config, items, search }))
}

/**
 * @param {CallSearchApiProps} props
 */
export function getContractors({ apiConfig = EMPTY_OBJECT, config, search }) {
  return searchContractors({
    apiConfig,
    archived: search.archived,
    query: search.text,
  })
    .then(getData)
    .then(items => ({ config, items, search }))
}

/**
 * @param {CallSearchApiProps} props
 */
export function getUsers({ apiConfig = EMPTY_OBJECT, config, search }) {
  return searchUsers({
    apiConfig,
    archived: search.archived,
    search: search.text,
  })
    .then(getData)
    .then(items => ({ config, items, search }))
}
